import {
  PropsWithChildren,
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

interface ReportContextState {
  modalIsOpen: boolean;
  toggleModal: () => void;
}

const ReportContext = createContext<ReportContextState>({
  modalIsOpen: false,
  toggleModal: () => {},
});

const useReport = () => useContext(ReportContext);

const ReportProvider = ({ children }: PropsWithChildren) => {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

  const toggleModal = useCallback(() => {
    setModalIsOpen((prev) => !prev);
  }, []);

  const value = useMemo(
    () => ({
      modalIsOpen,
      toggleModal,
    }),
    [modalIsOpen, toggleModal]
  );

  return (
    <ReportContext.Provider value={value}>{children}</ReportContext.Provider>
  );
};

export { ReportProvider, useReport };
